<template>
  <div class="service-wrap pt-20 pb-20">
    <div class="container">

      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-6" v-for="(article, index) in truncatedArticles" :key="index">
          <div class="blog-card style1">
            <div
              class="blog-img"
              :style="{
                height: '277px',
                backgroundImage: `url(${getUrlApiForFiles(article.urlImage)})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
              }"
            ></div>
            <div class="blog-info" style="min-height: 250px;">
              <ul class="blog-metainfo list-style">
                <li><i class="flaticon-user"></i> EITP</li>
                <li><i class="flaticon-calendar"></i>{{ format_Date(article.datePublication) }}</li>
              </ul>
              <h3>
                <router-link :to="{ name: 'ViewArticlePage', params: { id: article.id } }">
                  {{ article.titre }}
                </router-link>
              </h3>
              <router-link
                :to="{ name: 'ViewArticlePage', params: { id: article.id } }"
                class="link style1"
              >
                Lire plus <i class="flaticon-right-arrow"></i>
              </router-link>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <PaginationComponent
          :page="page"
          :totalPages="totalPages"
          :totalElements="totalElements"
          :limit="limit"
          @paginate="handlePaginate"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ApiService from "@/services/ApiService";
import { getUrlApiForFiles, error, format_Date } from "@/utils/utils";
import { defineComponent, ref, onMounted, computed } from "vue";
import { Article } from "@/models/Article";
import PaginationComponent from '@/components/Utilities/Pagination.vue';

export default defineComponent({
  name: 'ChronosKairos',
  components: { PaginationComponent },
  setup() {
    const articles = ref<Array<Article>>([]);

    // PAGINATION
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(9);
    const totalElements = ref(0);

    const handlePaginate = ({ page_, limit_ }) => {
      page.value = page_;
      getArticles(page_, limit_);
    };

    // Récupérer les articles de la catégorie "Chronos et ratios"
    function getArticles(page = 1, limi = 9) {
      return ApiService.get(
        `/actualite/articles/20?page=${page}&limit=${limi}&categorie=chronos-et-ratios`
      )
        .then(({ data }) => {
          articles.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
        })
        .catch(({ response }) => {
          error(response?.data?.message || "Erreur de chargement");
        });
    }

    const truncatedArticles = computed(() => {
      const maxLength = 80;
      return articles.value.map(article => ({
        ...article,
        titre: article.titre.length > maxLength
          ? article.titre.substring(0, maxLength) + '...'
          : article.titre
      }));
    });

    onMounted(() => {
      getArticles();
    });

    return {
      articles,
      getUrlApiForFiles,
      format_Date,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      truncatedArticles
    };
  },
});
</script>

<style scoped>
.blog-card .blog-info h3 {
  font-size: 20px;
  line-height: 30px;
  margin-bottom: 15px;
}
</style>